
import { Component, Vue, Watch } from 'vue-property-decorator'
import ToggleSwitch from '@/components/ToggleSwitch.vue'

@Component({
  components: {
    ToggleSwitch
  }
})
export default class PronosticoMeteorologicoControl extends Vue {
  isVector: boolean | null = null;

  mounted () {
    this.checkVector(this.isVector, this.$route.query.vector)
  }

  get isSubmenuSelected () {
    return this.$route.path === '/pronostico-meteorologico'
  }

  get queryVector () {
    if (this.isVector) {
      return {
        vector: this.isVector ? true : undefined
      }
    }
    return undefined
  }

  async toggleChanged (value: boolean) {
    this.isVector = value
    const newVector = (value) ? 'true' : undefined
    try {
      const queryVector = this.$route.query.vector
      if (queryVector !== newVector) {
        if (newVector) {
          this.$router.push({
            query: Object.assign({}, this.$route.query, { vector: newVector })
          })
        } else {
          let query = Object.assign({}, this.$route.query)
          delete query.vector
          this.$router.replace({ query })
        }
      }
    } catch (e) {
      console.warn(e)
    }
  }

  @Watch('$route.query.vector')
  vectorQueryChanged (newValue: any) {
    this.checkVector(this.isVector, newValue)
  }

  checkVector (value: any, query: any) {
    const isVector = !!value
    const isVectorQuery = !!query
    if (isVector !== isVectorQuery) {
      // @ts-ignore
      this.$refs.toggleSwitch.inputClick()
    }
  }
}
